import { render } from "./Founder.vue?vue&type=template&id=2b4fc262&scoped=true"
import script from "./Founder.vue?vue&type=script&lang=js"
export * from "./Founder.vue?vue&type=script&lang=js"

import "./Founder.vue?vue&type=style&index=0&id=2b4fc262&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4fc262"]])

export default __exports__